import {sameValueZero} from './js_utils.ts';

/**
 * Recursively compares two objects for equality.
 * Returns as soon as it finds a difference.
*/
const recursiveDiffEquals = (entry1: unknown, entry2: unknown): boolean => {
  if (entry1 && entry2 && typeof entry1 === 'object' && typeof entry2 === 'object') {
    const obj1 = entry1 as Record<string, unknown>;
    const obj2 = entry2 as Record<string, unknown>;
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!recursiveDiffEquals(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }
  return sameValueZero(entry1, entry2);
};

const DIFF_EXCLUDED_KEYS = new Set(['title_blocks', 'fonts']);

/**
 * Recursively compares two pages for equality, skipping known ignored diffs
 * Returns as soon as it finds a difference.
*/
export const pagesEqual = (entry1: unknown, entry2: unknown): boolean => {
  if (entry1 && entry2 && typeof entry1 === 'object' && typeof entry2 === 'object') {
    const obj1 = entry1 as Record<string, unknown>;
    const obj2 = entry2 as Record<string, unknown>;
    // SVGs are not considered diff if the title_blocks or fonts change
    // See https://github.com/AllSpiceIO/crysknife/blob/1f72da1f3bb8e7ef6a9d6359b47695bcb88d82e7/crysknife_lib/src/ir/sch/diff.rs#L79 for details
    const keys1 = Object.keys(obj1).filter((k) => !DIFF_EXCLUDED_KEYS.has(k));
    const keys2 = Object.keys(obj2).filter((k) => !DIFF_EXCLUDED_KEYS.has(k));

    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!recursiveDiffEquals(obj1[key], obj2[key])) {
        return false;
      }
    }
    return true;
  }

  return sameValueZero(entry1, entry2);
};
